import { StyleSheet } from 'aphrodite'

import partner from './partner'
import main from './main'
import sidebar from './sidebar'

export default {
  main: StyleSheet.create(main),
  partner: StyleSheet.create(partner),
  sidebar: StyleSheet.create(sidebar)
}



// WEBPACK FOOTER //
// ./src/components/Partnets/style/index.js